import type { FC } from 'react';
import type { FootprintVolatilityCurvesProps } from './types';
import FootprintVolatilityCurvesWidget from './footprint-volatility-curves-widget';
import { FootprintVolatilityCurvesProvider } from '../../../../providers/widgets/footprint-volatility-curves-provider/footprint-volatility-curves-provider';
import { GetVolProvider } from '../../../../providers/get-vol-provider';
import { DataLabelEnum } from '../../../../model/data_label.enum';

const FootprintVolatilityCurvesWrapperProvider: FC<FootprintVolatilityCurvesProps> = (props) => (
  <GetVolProvider providerKey={props.providerKey} label={DataLabelEnum.PERPETUAL}>
    <FootprintVolatilityCurvesProvider providerKey={props.providerKey}>
      <FootprintVolatilityCurvesWidget {...props} />
    </FootprintVolatilityCurvesProvider>
  </GetVolProvider>
);

export default FootprintVolatilityCurvesWrapperProvider;
